import {
  actualizarDimension,
  crearDimension,
  eliminarDimension,
  getDimensiones,
} from 'api/dimension'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import swal from 'sweetalert2'

const key = 'dimensions'
export function useObtenerDimension(buscar) {
  return useQuery(key, () => getDimensiones(buscar))
}

export function useCrearDimension() {
  const queryClient = useQueryClient()
  return useMutation(crearDimension, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarDimension() {
  const queryClient = useQueryClient()
  return useMutation(actualizarDimension, {
    onSuccess: (_, value) => {
      const { id, values: dimensionActualizada } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((dimension) => {
          let nuevaDimension = dimension
          if (id === dimension.id) {
            nuevaDimension = dimensionActualizada
          }
          return nuevaDimension
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarDimension() {
  const queryClient = useQueryClient()
  return useMutation(eliminarDimension, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (dimension) => dimension.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useDimension(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarDimension } = useEliminarDimension()
  const { mutateAsync: actualizarDimension } = useActualizarDimension()
  const { mutateAsync: crearDimension } = useCrearDimension()

  const handleCrearDimension = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearDimension(values)
      const message = `La dimensión ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarDimension = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarDimension({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La dimensión fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarDimension = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarDimension(id)
          const message = `La dimensión ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarDimension = async (value) => {
    queryClient.prefetchQuery(key, () => getDimensiones(value))
  }

  return {
    obtenerDimensiones: useObtenerDimension,
    handleEliminarDimension,
    handleActualizarDimension,
    handleCrearDimension,
    handleBuscarDimension,
  }
}
